<div class="localization-widget-container">
  <div class="widget-container" *ngIf="previewNotAvailable">
    WIDGET PREVIEW NOT AVAILABLE
  </div>
  <div class="widget-container box-content">
    <div *ngIf="availableLayouts" class="layout-dropdown">
      <kendo-dropdownlist  [data]="availableLayouts"
      (valueChange)="onLayoutChanged($event)" [(ngModel)]="selectedLayout"></kendo-dropdownlist>
    </div>
    <ng-template localizationWidgetHost></ng-template>
  </div>
</div>
